/** Shared primitive/value types used across the estimator domain. */

/** All monetary values in the system are Canadian dollars, whole-dollar precision. */
export type CurrencyCode = "CAD";

export interface Money {
  amount: number; // whole CAD dollars; UI is responsible for locale formatting
  currency: CurrencyCode;
}

export interface MoneyRange {
  low: Money;
  typical: Money;
  high: Money;
}

export type LengthUnit = "sqft" | "sqm";

export interface Dimensioned {
  value: number;
  unit: LengthUnit;
}

/** ISO 3166-2:CA province/territory codes. */
export const CANADIAN_PROVINCES = [
  "AB",
  "BC",
  "MB",
  "NB",
  "NL",
  "NS",
  "NT",
  "NU",
  "ON",
  "PE",
  "QC",
  "SK",
  "YT"
] as const;

export type ProvinceCode = (typeof CANADIAN_PROVINCES)[number];

export interface Location {
  province: ProvinceCode;
  city?: string;
  postalCode?: string;
  /** Free-text fallback when the user's location can't be resolved to a known region row. */
  rawLocationInput?: string;
}

export type ScopeLevel = "cosmetic_refresh" | "mid_range_remodel" | "full_gut_renovation" | "custom_high_end";

export type FinishLevel = "budget" | "standard" | "premium" | "luxury";

export type ConfidenceLevel = "low" | "medium" | "high";

export type YesNoUnknown = "yes" | "no" | "unknown";

export interface Timeline {
  desiredStartWindow?: "asap" | "1_3_months" | "3_6_months" | "6_12_months" | "flexible";
  flexible: boolean;
}
